import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlToSimpleTextPipe',
})
export class HtmlToSimpleTextPipe implements PipeTransform {
  htmlcontent!: string;
  output!: any;
  removedh1!: string;

  htmlEntitiesMap: { [key: string]: string } = {
    '&#160;': ' ',
    '\u00a0': ' ',
    '&radic;': '√',
    '&theta;': 'θ',
    '&alpha;': 'α',
    '&sup2;': '²',
    '&nbsp;': ' ',
    '&lt;': '<',
    '&gt;': '>',
    '&amp;': '&',
    '"': ''
  };

  transform(htmlContent: any): any {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = htmlContent;
    return tmp.innerText.toString();
  }

  cleanHTML(content: string, removeQuotes: boolean = false): string {
    if (!content) return '';

    let cleaned = content.replace(/&#160;|\u00a0|&radic;|&theta;|&alpha;|&sup2;|&nbsp;|&lt;|&gt;|&amp;|"/g, 
      match => this.htmlEntitiesMap[match] || '');

    return removeQuotes ? cleaned.replace(/"/g, '') : cleaned;
  }

  RemoveHTML(content: string): string {
    return this.cleanHTML(content);
  }

  getHtmlSimpleText(htmlContent: string): string {
    return htmlContent.replace(/(<([^>]+)>)/gi, '');
  }
  
  RemoveHTMLForSchema(content: string): string {
    return this.cleanHTML(content, true);
  }

  configurLatex(content: string): string {
    return this.cleanHTML(content).replace(/\\/g, '\\\\').trim();
  }

  RemoveH1(content: string): string {
    if (!content) return '';
    return content.replaceAll('&gt;', '>').replaceAll('&lt;', '<').replace(/h1/gi, 'div')
      .replaceAll('style=', '').replace(/<style\b[^>]*>[\s\S]*?<\/style>/g, '')
      .replaceAll('<hr>', '').replaceAll('href=', '').trim();
  }

  removeHrefHr(content: string): string {
    return content.replaceAll('href=', '').replaceAll('<hr>', '').replaceAll('style=', '');
  }

  RemoveHTMLForSEO(content: string): string {
    if (!content) return '';

    return content.replace(/<\/?(?!sup|sub|math|mrow|mi|mo|mn|mfrac|mroot|mtext|mstyle|msup|msub|msubsup)[a-zA-Z][a-zA-Z0-9]*[^>]*>/g, '')
      .replace(/<script[^>]*(?<!\/)>.*?<\/script>|<style[^>]*(?<!\/)>.*?<\/style>/g, '')
      .replace(/<[^>]+>|\&nbsp\;/g, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/&#160;|\u00a0|&radic;|&theta;|&alpha;|&sup2;|&nbsp;|&lt;|&gt;|&amp;|"/g, match => this.htmlEntitiesMap[match] || '')
      .replace(/"/g, '');
  }

  toTitleCase(input: string): string {
    return input.toLowerCase().trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
